import {CHARACTER_CATALOG as catalog,defaultCharacterAppearance,normalizeCharacterAppearance,type CharacterAppearance} from '../player/characterAppearance';
import {characterImage} from '../player/characterImages';
import {cityIcon} from './icons';

type Part='body'|'hair'|'top'|'pants'|'shoes'|'beard'|'moustache';
type Category=Part|'presets'|'route';
const categories:ReadonlyArray<[Category,string,string]>=[['presets','آواتارهای آماده','users'],['body','کاراکتر','users'],['hair','مدل مو','customizer'],['top','لباس','products'],['pants','شلوار','variants'],['shoes','کفش','products'],['beard','ریش','users'],['moustache','سبیل','users'],['route','مسیر حرکت','pin']];
const colorField:Partial<Record<Part,keyof CharacterAppearance>>={hair:'hairColor',top:'topColor',pants:'pantsColor',shoes:'shoesColor',beard:'facialColor',moustache:'facialColor'};

/** Catalog selection only. Persistence and the world scene belong to the workshop. */
export class CharacterCustomizer{
 readonly element=document.createElement('section');
 private readonly nav=document.createElement('nav');
 private readonly content=document.createElement('div');
 private readonly status=document.createElement('small');
 private value=defaultCharacterAppearance();
 private active:Category='presets';
 private custom=false;
 private presets?:HTMLElement;
 private route?:HTMLElement;
 private revision=0;
 private disposed=false;
 private readonly thumbnails=new Map<string,Promise<string>>();
 constructor(private readonly onChange:(value:CharacterAppearance)=>void,private readonly onMode:(route:boolean)=>void=()=>{}){
  this.element.className='city-character-customizer';
  this.element.setAttribute('aria-label','شخصی‌سازی کاراکتر');
  this.nav.className='city-workshop-categories';this.nav.setAttribute('aria-label','دسته‌بندی آواتار');
  this.content.className='city-character-catalog';
  this.status.setAttribute('role','status');this.status.className='city-character-customizer__status';
  for(const [id,title,icon]of categories){
   const button=document.createElement('button');button.type='button';button.dataset.characterCategory=id;button.append(cityIcon(icon),document.createTextNode(title));
   button.onclick=()=>this.selectCategory(id);this.nav.append(button);
  }
  this.element.append(this.nav,this.content,this.status);this.render();
 }
 usePreset():void{this.custom=false;}
 private selectCategory(category:Category):void{
  this.active=category;
  if(category!=='presets'&&category!=='route'&&!this.custom){this.custom=true;this.onChange({...this.value});}
  this.render();this.onMode(category==='route');
 }
 setPanels(presets:HTMLElement,route:HTMLElement):void{this.presets=presets;this.route=route;this.render();}
 setValue(value?:CharacterAppearance):void{
  this.custom=!!value;this.value=value?normalizeCharacterAppearance(value):defaultCharacterAppearance();
  this.active=value?'top':'presets';this.render();this.onMode(false);
 }
 private choose(field:Part,id:string):void{
  const next={...this.value,[field]:id};
  if(field==='body')next.hair=catalog.hair[next.body][0].id;
  this.value=normalizeCharacterAppearance(next);this.custom=true;this.onChange({...this.value});this.render();
 }
 private render():void{
  const revision=++this.revision;
  for(const button of this.nav.querySelectorAll<HTMLButtonElement>('button'))button.setAttribute('aria-pressed',String(button.dataset.characterCategory===this.active));
  this.content.replaceChildren();this.status.textContent='';
  if(this.active==='presets'||this.active==='route'){
   const panel=this.active==='presets'?this.presets:this.route;
   if(panel)this.content.append(panel);return;
  }
  const part=this.active;
  const heading=document.createElement('h2');heading.textContent=categories.find(c=>c[0]===part)![1];this.content.append(heading);
  const hint=document.createElement('p');hint.className='city-workshop-caption';hint.textContent='یک مدل انتخاب کن؛ رنگ‌بندی همان مدل پایین کارت‌هاست.';this.content.append(hint);
  const grid=document.createElement('div');grid.className='city-character-grid';
  const options=part==='hair'?catalog.hair[this.value.body]:catalog[part];
  for(const item of options){
   const button=document.createElement('button');button.type='button';button.className='city-character-item';button.dataset.characterField=part;button.dataset.item=item.id;
   button.setAttribute('aria-pressed',String(this.custom&&this.value[part]===item.id));button.setAttribute('aria-label',item.name);
   const visual=document.createElement('div');visual.className='city-character-item__art';
   if(item.id==='none')visual.append(cityIcon('close'));
   else{
    const image=document.createElement('img');image.alt='';image.width=96;image.height=96;visual.append(image);
    void this.thumbnail(part,item.id).then(url=>{if(revision===this.revision&&!this.disposed)image.src=url;}).catch(()=>{if(revision===this.revision)visual.replaceChildren(cityIcon('image'));});
   }
   const title=document.createElement('span');title.textContent=item.name;button.append(visual,title);button.onclick=()=>this.choose(part,item.id);grid.append(button);
  }
  this.content.append(grid);
  const field=colorField[part];
  if(field&&this.value[part]!=='none'){
   const group=document.createElement('fieldset');group.className='city-character-colors';
   const legend=document.createElement('legend');legend.textContent='رنگ‌بندی این مدل';group.append(legend);
   for(const color of catalog.colors){
    const button=document.createElement('button');button.type='button';button.title=color.name;button.setAttribute('aria-label',color.name);button.dataset.color=color.id;button.style.setProperty('--character-color',color.hex);button.setAttribute('aria-pressed',String(this.value[field]===color.id));
    button.onclick=()=>{this.value={...this.value,[field]:color.id};this.custom=true;this.onChange({...this.value});this.render();};group.append(button);
   }
   this.content.append(group);
  }
 }
 private thumbnail(part:Part,id:string):Promise<string>{
  const key=part+':'+id;
  let pending=this.thumbnails.get(key);if(pending)return pending;
  const value=part==='body'?defaultCharacterAppearance(id as 'man'|'woman'):this.value;
  pending=characterImage(value,true,1,part==='body'?undefined:part+'-'+id).then(bitmap=>{
   try{
    const raw=document.createElement('canvas');raw.width=80;raw.height=96;const ctx=raw.getContext('2d')!;ctx.drawImage(bitmap,0,0);
    const pixels=ctx.getImageData(0,0,80,96).data;let x0=80,y0=96,x1=0,y1=0;
    for(let y=0;y<96;y++)for(let x=0;x<80;x++)if(pixels[(y*80+x)*4+3]>20){x0=Math.min(x0,x);y0=Math.min(y0,y);x1=Math.max(x1,x);y1=Math.max(y1,y);}
    const out=document.createElement('canvas');out.width=128;out.height=128;
    if(x1>=x0&&y1>=y0){const w=x1-x0+1,h=y1-y0+1,scale=Math.min(104/w,104/h);const context=out.getContext('2d')!;context.imageSmoothingEnabled=false;context.drawImage(raw,x0,y0,w,h,(128-w*scale)/2,(128-h*scale)/2,w*scale,h*scale);}
    return out.toDataURL('image/png');
   }finally{bitmap.close();}
  });this.thumbnails.set(key,pending);void pending.catch(()=>this.thumbnails.delete(key));return pending;
 }
 destroy():void{this.disposed=true;this.revision++;this.thumbnails.clear();this.element.remove();}
}
